/**
 * 요금표 쿼리 키와 서버 프리페치.
 * 서버 프리페치(pricing/page.tsx)와 클라이언트 훅(pricing.query.ts)이 같은 키를 써야
 * 하이드레이션이 맞물린다. 어긋나면 곧바로 다시 요청해 서버가 실은 요금표가 버려진다.
 */
import { QUERY_KEYS } from '@/services/base-api';
import { getPricingList } from '@/services/pricing.service';
import { QueryClient } from '@tanstack/react-query';

export function pricingListQueryKey() {
  return [QUERY_KEYS.PRICING, QUERY_KEYS.LIST] as const;
}

/** 요금표를 서버 쿼리 캐시에 넣는다. 실패하면 비워 두고 클라이언트가 다시 받는다. */
export function prefetchPricingList(queryClient: QueryClient) {
  return queryClient.prefetchQuery({
    queryKey: pricingListQueryKey(),
    queryFn: getPricingList,
  });
}
